import { render, staticRenderFns } from "./SetupTour.vue?vue&type=template&id=58cba570&scoped=true"
import script from "./SetupTour.vue?vue&type=script&lang=js"
export * from "./SetupTour.vue?vue&type=script&lang=js"
import style0 from "./SetupTour.vue?vue&type=style&index=0&id=58cba570&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cba570",
  null
  
)

export default component.exports